export function normalizePersonalNumber(personalNumber: string): string {
	let normalizedPersonalNumber = personalNumber.replace(/[+-]/, "");

	// If a 10-digit personal number is passed in we need to figure out whether to prefix with 19 or 20
	// depending on if date prefixed with 20 is more then 18 years ago.
	// Example: 0106081234 will resolve in sanitized personal number 200106081324
	// and 1708241234 will resolve to 191708241234
	if (normalizedPersonalNumber.length === 10) {
		const personalNumberDate = new Date(
			2000 + parseInt(normalizedPersonalNumber.substring(0, 2), 10) + 18,
			parseInt(normalizedPersonalNumber.substring(2, 4), 10) - 1,
			parseInt(normalizedPersonalNumber.substring(4, 6), 10)
		);
		normalizedPersonalNumber =
			Date.now() > personalNumberDate.getTime()
				? `20${normalizedPersonalNumber}`
				: `19${normalizedPersonalNumber}`;
	}

	return normalizedPersonalNumber;
}
